<template>
  <router-link :to="to" :data-type="type" :data-size="size" class="c-transitionButton">
    <span class="c-transitionButton__inner"><slot></slot></span>
  </router-link>
</template>

<script>
  /**
   * Share Partial
   */

  export default {
    name: 'transition-button',
    components: {
    },
    data () {
      return {
      }
    },
    props: {
      to: {
        // type: String,
        required: true
      },
      type: {
        type: String,
        default: 'default'
      },
      size: {
        type: String,
        default: 'default'
      }
    },
    watch: {
    },
    computed: {
    },
    created() {
    },
    mounted() {
    },
    methods: {
    }
  }
</script>



// WEBPACK FOOTER //
// src/partial/transition-button.vue